import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./SectionHeader.module.css";
/**
 * Cabeçalho de seção de configuração do Azim CRM.
 * Explicita título, propósito e efeito da seção, com slot de ação à direita.
 */
export function SectionHeader({ title, purpose, effect, action, id }) {
    return (_jsxs("header", { className: styles.root, children: [_jsxs("div", { className: styles.text, children: [_jsx("h2", { id: id, className: styles.title, children: title }), _jsx("p", { className: styles.purpose, children: purpose }), effect && _jsx("p", { className: styles.effect, children: effect })] }), action && _jsx("div", { className: styles.action, children: action })] }));
}
//# sourceMappingURL=SectionHeader.js.map